/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// DO NOT MODIFY
// FILE GENERATED BY `intl-codegen@2.2.1`
// https://github.com/eversport/intl-codegen
// DO NOT MODIFY

import { defineLoader } from "intl-codegen/runtime";

export const loadLanguage = defineLoader([
  "activityDetailsCalendarRoom",
  "activityDetailsCalendarTrainer",
  "activityDetailsCalendarViewInfo",
  "addVoucher",
  "additionalInfoAddOns",
  "additionalInfoDesc",
  "additionalInfoMultiAnswerPatronQuestionSubtitle",
  "additionalInfoMultiAnswerPatronQuestionTitle",
  "additionalInfoPatronQuestion",
  "additionalInfoPoliciesEversportsGets",
  "additionalInfoPoliciesIAcceptTheTerm",
  "additionalInfoPoliciesPleaseAcceptTerms",
  "additionalInfoPoliciesPrivacyPolicy",
  "additionalInfoPoliciesTermsOf",
  "additionalInfoPoliciesTermsOfServicesPolicy",
  "additionalInfoPoliciesWhenYouBookOnline",
  "additionalInfoRequiredInfoDesc",
  "additionalInfoSubtitle",
  "additionalInfoTitle",
  "additionalPass",
  "all",
  "appPromotionContent",
  "appPromotionContentSelfCheckInStep1",
  "appPromotionContentSelfCheckInStep2",
  "appPromotionContentSelfCheckInStep3",
  "appPromotionHeading",
  "appPromotionHeadingSelfCheckIn",
  "applyVoucher",
  "assignedProductAutoExtensionDate",
  "assignedProductRemainingUsages",
  "assignedProductUsageLimitPeriod",
  "assignedProductValidUntil",
  "automaticExtension",
  "back",
  "blockingErrorMessage",
  "bookingConfirmationHeading",
  "bookingConfirmationHeadingNotConfirmed",
  "bookingConfirmationSubHeading",
  "bookingConfirmationSubHeadingNoConfirmed",
  "bookingConfirmationSubHeadingUnbranded",
  "bookingConfirmationSubHeadingWithoutSelfCheckIn",
  "bookingDetails",
  "bookingDetailsAssignedSpot",
  "bookingDetailsAssignedSpotMissing",
  "bookingLimitation",
  "bookingPaymentConfirmationHeading",
  "bookingRules",
  "bookingRulesHeader",
  "cancelVoucher",
  "cancellationConditions",
  "cancellationPeriod",
  "cancellationPeriodInterval",
  "collapseDetails",
  "confirmationButtonAddToCalendar",
  "confirmationButtonInviteFriends",
  "confirmationButtonModifySpot",
  "confirmationButtonMyBookings",
  "confirmationButtonMyRecording",
  "confirmationButtonMyRecordings",
  "confirmationButtonWebsite",
  "corporateBenefit",
  "corporateBenefitsLearnMore",
  "corporateBenefitsPricingToggle",
  "corporateBenefitsPricingToggleAriaLabel",
  "corporateBudgetDefaultName",
  "corporateBudgetEmployeeBudgetDepleted",
  "corporateBudgetProvidedBy",
  "corporateBudgetSharedInformationAmount",
  "corporateBudgetSharedInformationDataProtectionLink",
  "corporateBudgetSharedInformationDate",
  "corporateBudgetSharedInformationEmail",
  "corporateBudgetSharedInformationLegalBasis",
  "corporateBudgetSharedInformationName",
  "corporateBudgetSharedInformationPurpose",
  "corporateBudgetSharedInformationText",
  "corporateBudgetSharedInformationTitle",
  "corporateBudgetTotalBudgetDepleted",
  "corporatePricingBudgetLabel",
  "corporatePricingDiscountLabel",
  "courtBookingDetailsName",
  "courtbookingCommentboxHeading",
  "dateUnitDay",
  "dateUnitDayPlural",
  "dateUnitGame",
  "dateUnitGamePlural",
  "dateUnitHour",
  "dateUnitHourPlural",
  "dateUnitMinute",
  "dateUnitMinutePlural",
  "dateUnitMonth",
  "dateUnitMonthPlural",
  "dateUnitSeason",
  "dateUnitSeasonPlural",
  "dateUnitUnit",
  "dateUnitUnitPlural",
  "dateUnitWeek",
  "dateUnitWeekPlural",
  "dateUnitWeekend",
  "dateUnitWeekendPlural",
  "dateUnitYear",
  "dateUnitYearPlural",
  "dateAndTime",
  "downloadInvoice",
  "downloadVoucher",
  "emptyActivities",
  "endTime",
  "enterYourCommentHere",
  "eventBookingDetailsName",
  "eversports",
  "eversportsDataProtectionDeclaration",
  "expandDetails",
  "fieldBirthday",
  "fieldCity",
  "fieldCountry",
  "fieldDetail",
  "fieldFiscalCode",
  "fieldFiscalCodeDisclaimer",
  "fieldPhoneNumber",
  "fieldStreet",
  "fieldZip",
  "firstPartialPaymentInfo",
  "freeProductConfirmationHeading",
  "headerSecureCheckout",
  "hideVoucherRedemption",
  "howWouldLikeBookCourt",
  "idealPaymentSelectYourBank",
  "includedActivities",
  "incorrectUser",
  "incorrectUserDescription",
  "interval",
  "intervalIncludingSingleNumber",
  "invoiceAndPurchaseConfirmationHeading",
  "invoiceAndPurchaseConfirmationSubHeading",
  "invoiceFrom",
  "invoiceNumber",
  "medicalCertificateExpired",
  "medicalCertificateExpiring",
  "medicalCertificateMissing",
  "medicalCertificateReminder",
  "membership",
  "membershipCancelAnytime",
  "membershipConditions",
  "membershipDueDate",
  "membershipInterval",
  "membershipMinRuntime",
  "membershipModalInterval",
  "membershipPaymentInformation",
  "membershipPaymentTermsInfo",
  "membershipPaymentTermsTitle",
  "membershipPrice",
  "membershipPromotionSummaryMonths",
  "membershipPromotionSummaryWeeks",
  "membershipRuntime",
  "membershipStartingDate",
  "membershipUsages",
  "month",
  "monthlyAvailabilityPeriod",
  "multiDayAvailabilityPeriod",
  "multiSessionEvent",
  "multiSessionSharingMessage",
  "myPasses",
  "networkErrorDescription",
  "networkErrorMessage",
  "newPass",
  "next",
  "no",
  "noAvailableProductForOnlinePurchase",
  "noPaymentMethodAvailable",
  "numberAddOnPlaceholder",
  "offlinePaymentSubtitle",
  "onlineLocation",
  "orderAbortedError",
  "orderAlreadyConfirmed",
  "orderTimeoutError",
  "partialPayment",
  "partialPaymentDisclaimer",
  "partialPaymentInterval",
  "partialPaymentPeriod",
  "participationOptions",
  "patronageAnswerEversports",
  "patronageAnswerVenueChannels",
  "patronageAnswerVenueCustomer",
  "patronageAnswerVenueMembers",
  "payOffline",
  "payWith",
  "payWithSepa",
  "paymentUnitEuro",
  "paymentAdditionalPaymentMethodsApplePay",
  "paymentAdditionalPaymentMethodsBancontact",
  "paymentAdditionalPaymentMethodsBizum",
  "paymentAdditionalPaymentMethodsGooglePay",
  "paymentAdditionalPaymentMethodsHeading",
  "paymentAdditionalPaymentMethodsIdeal",
  "paymentAdditionalPaymentMethodsMastercard",
  "paymentAdditionalPaymentMethodsMultibanco",
  "paymentAdditionalPaymentMethodsPayOnSite",
  "paymentAdditionalPaymentMethodsPayWith",
  "paymentAdditionalPaymentMethodsPaypal",
  "paymentAdditionalPaymentMethodsSatispay",
  "paymentAdditionalPaymentMethodsSepa",
  "paymentAdditionalPaymentMethodsTwint",
  "paymentAdditionalPaymentMethodsVisa",
  "paymentChargeInfo",
  "paymentDetails",
  "paymentErrorCancelled",
  "paymentErrorFailed",
  "paymentErrorRequestTimeout",
  "paymentErrorStripeSource",
  "paymentHeading",
  "paymentInfoBannerIdeal",
  "paymentMethodInformation",
  "paymentMethodOfflineInformation",
  "paymentPayWithCreditCardAddNewCard",
  "paymentPayWithCreditCardAddNewCreditCard",
  "paymentPayWithCreditCardHeading",
  "paymentPayWithCreditCardSavedCreditCards",
  "paymentPayWithIdealHeading",
  "paymentPayWithSepaIdealHeading",
  "paymentProviderTitle",
  "paymentTimer",
  "periodOfValidity",
  "pleaseChooseAnOption",
  "pleaseEnterAVoucher",
  "poweredByStripe",
  "preparingYourOrder",
  "price",
  "privateSessionBookingRequestConfirmationHeading",
  "privateSessionBookingRequestSubheading1",
  "privateSessionBookingRequestSubheading2",
  "privateSessionsWithoutAppointments",
  "processingPayment",
  "product",
  "productBookingRules",
  "productConditionsTitle",
  "productDescription",
  "productDetails",
  "productInfo",
  "productInfoAriaLabel",
  "productPrice",
  "productSupportedVenues",
  "productUsageConditions",
  "productValidityConditions",
  "productValidityStart",
  "purchaseConfirmationSubHeading",
  "recordingAvailableUntil",
  "recordingDetails",
  "recordingOriginalStreamingTime",
  "recordingTrainer",
  "returnToLogin",
  "saveCard",
  "security",
  "sepaAgreement",
  "sepaBankAccountHolder",
  "sepaDisclaimer",
  "sepaNewBankAccount",
  "sepaPaymentInformation",
  "sepaSavedBankAccountHeader",
  "sepaUnverifiedBankAccount",
  "sepaVerifyWithPaymentInformation",
  "shareIt",
  "shareWithFriends",
  "showLess",
  "showMore",
  "showVoucherRedemption",
  "singleDayAvailabilityPeriod",
  "singlePurchase",
  "singleSessionSharingMessage",
  "singleTimeBlock",
  "sofortPaymentSelectYourBankCountry",
  "spotBookingInformation",
  "startOfRegularRuntime",
  "startTime",
  "startingDate",
  "stepAdditionalInformation",
  "stepChooseActivity",
  "stepChooseProduct",
  "stepChooseVideo",
  "stepConfirmation",
  "stepPayment",
  "stepReviewInformation",
  "summaryButtonBookNow",
  "summaryButtonConfirm",
  "summaryButtonContinue",
  "summaryButtonPay",
  "summaryChooseProduct",
  "summaryPartialPaymentPeriod",
  "summaryParticipateWith",
  "summaryStartOfRegularRuntime",
  "summaryTitle",
  "summaryTotal",
  "summaryTotalVat",
  "testText",
  "textAddOnPlaceholder",
  "ticketEarlyBirdDisclaimer",
  "ticketEarlyBirdPrice",
  "ticketEarlyBirdUntil",
  "ticketEarlyBirdValidUntil",
  "ticketLastMinutePrice",
  "ticketRegularPrice",
  "ticketsIncludedSessions",
  "timeLimit",
  "timeRestrictions",
  "trialOffers",
  "unexpectedErrorDescription",
  "unexpectedErrorMessage",
  "units",
  "unitsHeader",
  "unlimitedMembershipUsage",
  "validActivities",
  "validAt",
  "validForInterval",
  "validOnlyForThisEvent",
  "validSports",
  "validityStart",
  "voucherCode",
  "voucherConditions",
  "voucherDisclaimer",
  "voucherExpirationDate",
  "voucherPurchaseInformation",
  "voucherSuccessfullyApplied",
  "voucherValidUntil",
  "weekday",
  "weekdayPeriods",
  "yes",
  "yourBookingDetails",
  "yourPaymentDetails",
], {
  de: () => import("./locales/de.js"),
  en: () => import("./locales/en.js"),
  es: () => import("./locales/es.js"),
  nl: () => import("./locales/nl.js"),
  fr: () => import("./locales/fr.js"),
  it: () => import("./locales/it.js"),
}, "en");
